<template>
    <div id="stepOneForm" class="step-form">
        <p
            class="lead"
        >Please provide information about the production company and the location manager(s) you will be working with.</p>
        <form name="stepForm" autocomplete="off">
            <fieldset v-if="!newCompany">
                <div class="form-row">
                    <TypeaheadInput
                        ref="CompanyName"
                        inputId="CompanyName"
                        v-model.lazy="CompanyName"
                        labelText="Production company name"
                        @input="handleTypeaheadInput"
                        :isRequired="!newCompany"
                        :options="typeaheadList"
                        :wrapperClasses="['col-md-8']"
                        :disabled="companyListLoading || newCompany"
                        :loading="companyListLoading"
                        autocomplete="off"
                        aria-autocomplete="off"
                    />
                </div>

                <div class="form-row mt-3" v-if="selectedCompany && selectedCompany.CompanyName">
                    <div class="col-md-12">
                        <p>
                            <strong>{{CompanyName}}</strong>
                            <br />
                            {{CompanyAddressLine1}}
                            <template
                                v-if="CompanyAddressLine2 !== 'NO DATA PROVIDED'"
                            >
                                <br />
                                {{CompanyAddressLine2}}
                            </template>
                            <template v-if="CompanyPostalCode !== 'NO DATA PROVIDED'">
                                <br />
                                {{CompanyPostalCode}}
                            </template>
                            <template v-if="CompanyPhone !== 'NO DATA PROVIDED'">
                                <br />
                                {{CompanyPhone}}
                            </template>
                        </p>
                    </div>
                </div>
            </fieldset>

            <p class="lead">Can't find your production company in the list? Please check off the box to register production company information</p>
            <div class="form-row">
                <CheckboxInput
                    ref="newCompany"
                    inputId="newCompany"
                    labelText="Provide information for the production company so we can add it to our list"
                    :isRequired="false"
                    v-model="newCompany"
                    :labelAfter="true"
                />
            </div>
            <fieldset class="my-4" v-show="newCompany" :disabled="!newCompany">
                <div class="form-row">
                    <TextInput
                        inputId="CompanyName"
                        labelText="Company name"
                        :wrapperClasses="['col-md-8']"
                        v-model="CompanyName"
                        :isRequired="newCompany"
                        :validation="[{type:'max',value:30,msg:'The company name must be less than 30 characters'}]"
                    />
                </div>
                <div class="form-row">
                    <TextInput
                        inputId="CompanyEmail"
                        labelText="Company email"
                        :wrapperClasses="['col-md-8']"
                        v-model.trim="CompanyEmail"
                        :isRequired="newCompany"
                        :validation="newCompany ? [{type:'email',msg:'Please provide a valid email'}] : []"
                    />
                </div>
                <div class="form-row">
                    <TextInput
                        inputId="CompanyPhone"
                        labelText="Company phone number"
                        :wrapperClasses="['col-md-8']"
                        v-model="CompanyPhone"
                        :isRequired="newCompany"
                    />
                </div>
                <div class="form-row">
                    <TextInput
                        inputId="CompanyAddressLine1"
                        labelText="Company address"
                        :wrapperClasses="['col-md-8']"
                        placeholder="Address line 1"
                        v-model="CompanyAddressLine1"
                        :isRequired="newCompany"
                    />
                </div>
                <div class="form-row">
                    <TextInput
                        inputId="CompanyAddressLine2"
                        labelText="Company address line 2"
                        :wrapperClasses="['col-md-8']"
                        placeholder="Address line 2"
                        :srOnly="true"
                        v-model="CompanyAddressLine2"
                        :isRequired="Boolean(false)"
                    />
                </div>
                <div class="form-row">
                    <SelectInput
                        inputId="CompanyProvince"
                        labelText="Province"
                        v-model="CompanyProvince"
                        :options="provinces"
                        :isRequired="!newCompany"
                    />
                    <TextInput
                        inputId="CompanyCity"
                        labelText="Company city"
                        v-model="CompanyCity"
                        :isRequired="newCompany"
                    />
                </div>
                <div class="form-row">
                    <TextInput
                        inputId="CompanyPostalCode"
                        labelText="Postal code"
                        v-model="CompanyPostalCode"
                        :isRequired="newCompany"
                    />
                </div>
            </fieldset>

            <p class="form-step1-subheading">Location Contact Information</p> <!--Location manager details-->
            <p>This is the information you provided when you registered your account. To change this information contact the film office.</p>
            <div class="form-row">
                <div class="col-auto" v-if="!loading">
                    <p>
                        <strong>{{manager.name}}</strong>
                        <br />
                        {{manager.phone}}
                        <br />
                        {{manager.email}}
                    </p>
                </div>
                <div class="col-auto" v-else>
                    <p>Loading...</p>
                    <div class="spinner-container">
                        <div class="spinner"></div>
                    </div>
                </div>
            </div>


            <!--******** Asking whether or not account owner is "location manager"?************-->
            <p class="form-label">Are you ({{manager.name}}) the location manager?</p> 
            <div class="form-row mb-3">
                <RadioInput
                    inputId="isUserLocManager"
                    v-model="isUserLocManager"
                    name="isUserLocManager"
                    :options="[
                        { text: 'Yes', value: true },
                        { text: 'No', value: false },
                    ]"
                    :inline="false"
                    :optionalFlag="false"
                    :isRequired="false"
                />
            </div>

            
            <fieldset :class="{'d-none':isUserLocManager}" :disabled="isUserLocManager" v-show="!isUserLocManager"> 
                <div class="form-row">
                    <SelectInput
                        inputId="UserRole"
                        labelText="What is your role?"
                        v-model="UserRole"
                        :options="roles"
                        :isRequired="!isUserLocManager"
                    />
                </div>
                <hr class="my-4" />
                <p><b>Add Location Manager Info:</b></p>
                    <div class="form-row">
						<TextInput
							inputId="LocManagerFirstName"
							v-model="LocManagerFirstName"
							labelText="First name"
							:wrapperClasses="['col-md-4']"
                            :isRequired="!isUserLocManager"

						/>
						<TextInput
							inputId="LocManagerLastName"
							v-model="LocManagerLastName"
							labelText="Last name"
							:wrapperClasses="['col-md-4']"
                            :isRequired="!isUserLocManager"
						/>
					</div>
					<div class="form-row">
						<TextInput
							inputId="LocManagerEmail"
							v-model="LocManagerEmail"
							labelText="Email address"
							:wrapperClasses="['col-md-6']"
							:validation="!isUserLocManager ? [{type:'email',msg:'Please provide a valid email'}] : []"
							:validateEmail="false"
                            :isRequired="!isUserLocManager"
                            :optionalFlag="false"
						/>
					</div>
                    <div class="form-row">
						<TextInput
							inputId="LocManagerPhone"
                            v-model="LocManagerPhone"
							labelText="Phone"
							helpText="Example: 905-615-3200"
							:validation="!isUserLocManager ? [{type:'phone',value:null,msg:'Please input a valid phone number'}] : []"
                            :isRequired="!isUserLocManager"
                            :optionalFlag="false"
						/>
					</div>
                    <hr class="my-4" />
            </fieldset>
            


            <!--<p class="form-label">Will there be more than one location manager working on this permit?</p>-->
            <p class="form-label">Will there be any additional locations personnel working on this permit? </p>
            <!--
            <div class="form-row">
                <CheckboxInput
                    inputId="manager2"
                    labelText="Provide contact information for a second location manager"
                    :isRequired="false"
                    v-model="manager2"
                    :labelAfter="true"
                />
            </div>
            -->
            <!--CHANGED: display radio input rather than checkbox above *****************-->
            <div class="form-row mb-3">
                <RadioInput
                    inputId="manager2"
                    v-model="manager2"
                    name="manager2"
                    :options="[
                        { text: 'Yes', value: true },
                        { text: 'No', value: false },
                    ]"
                    :inline="false"
                    :optionalFlag="false"
                    :isRequired="false"
                />
            </div>


            <fieldset :class="{'d-none':!manager2}" :disabled="!manager2" v-show="manager2">
                <hr class="my-4" />
                <div class="form-row">
                    <SelectInput
                        inputId="Manager2Role"
                        labelText="What is additional person role?"
                        v-model="Manager2Role"
                        :options="roles"
                        :isRequired="manager2"
                    />
                </div>
                <div class="form-row">
                    <TextInput
                        inputId="Manager2FirstName"
                        labelText="First name"
                        v-model="Manager2FirstName"
                        :isRequired="manager2"
                        :wrapperClasses="['col-md-4']"
                    />
                    <TextInput
                        inputId="Manager2LastName"
                        labelText="Last name"
                        v-model="Manager2LastName"
                        :isRequired="manager2"
                        :wrapperClasses="['col-md-4']"
                    />
                </div>
                <div class="form-row">
                    <TextInput
                        inputId="Manager2Email"
                        labelText="Email"
                        :wrapperClasses="['col-md-8']"
                        :validation="manager2 ? [{type:'email',msg:'Please provide a valid email'}] : []"
                        v-model.trim="Manager2Email"
                        :isRequired="manager2"
                    />
                </div>
                <div class="form-row">
                    <TextInput
                        inputId="Manager2Phone"
                        labelText="Phone number"
                        :wrapperClasses="['col-md-8']"
                        :validation="manager2 ? [{type:'phone',msg:'Please provide a valid phone number'}] : []"
                        v-model="Manager2Phone"
                        :isRequired="manager2"
                    />
                </div>
            </fieldset>




            

            
            <!--****** Production Info Starts ***********-->
            <p class="form-step1-subheading mt-3 step-container">Production Information:</p>
            <div class="form-row mb-3">
                <TextInput
                    inputId="StudioLocation"
                    labelText="Studio location"
                    v-model="StudioLocation"
                    :validation="[
                        {
                            type: 'max',
                            value: 200,
                            msg: `Studio location can't be longer than 200 characters.`,
                        },
                    ]"
                    helpText="Enter your studio address."
                    :wrapperClasses="['col-md-8']"
                    :isRequired="true"
                />
            </div>
            <div class="form-row mb-3">
                <NumberInput
                    inputId="NumOfStudioDays"
                    labelText="Number of studio days"
                    v-model="NumOfStudioDays"
                    :validation="[
                        {
                            type: 'max',
                            value: 365,
                            msg: `Number of studio days can't be more than 365 days`,
                        },
                    ]"
                    :isRequired="true"
                    :allowZero="true"
                />
            </div>
            <div class="form-row mb-3">
                <TextInput
                    inputId="ProductionManager"
                    labelText="Production manager"
                    v-model="ProductionManager"
                    :validation="[
                        {
                            type: 'max',
                            value: 200,
                            msg: `Production manager can't be longer than 200 characters.`,
                        },
                    ]"
                    helpText="Enter production manager name."
                    :wrapperClasses="['col-md-8']"
                    :isRequired="true"
                />
            </div>
            <div class="form-row mb-3">
                <TextInput
                    inputId="ProducerName"
                    labelText="Producer name"
                    v-model="ProducerName"
                    :validation="[
                        {
                            type: 'max',
                            value: 200,
                            msg: `Producer name can't be longer than 200 characters.`,
                        },
                    ]"
                    helpText="Enter producer name."
                    :wrapperClasses="['col-md-8']"
                    :isRequired="true"
                />
            </div>
            <div class="form-row">
                <NumberInput
                    inputId="TOTALPRODBUDGET"
                    labelText="Total production budget"
                    v-model="TOTALPRODBUDGET"
                    :validation="[
                        {
                            type: 'max',
                            value: 999999999.99,
                            msg: `You can't have more than 999,999,999.99`,
                        },
                    ]"
                    :isRequired="true"
                />
                <SelectInput
                    inputId="TOTCADCB"
                    labelText="Currency"
                    v-model="TOTCADCB"
                    :options="currencySelect"
                />
            </div>
            <div class="form-row">
                <NumberInput
                    inputId="ESTSPEND"
                    labelText="Estimated spend in the City"
                    v-model="ESTSPEND"
                    :validation="[
                        {
                            type: 'max',
                            value: 999999999.99,
                            msg: `You can't have more than 999,999,999.99`,
                        },
                    ]"
                    :isRequired="true"
                />
                <SelectInput
                    inputId="ESTCADCB"
                    labelText="Currency"
                    v-model="ESTCADCB"
                    :options="currencySelect"
                />
            </div>
            <!--****** Production Info Ends ***********-->



        </form>
        <div
            class="alert alert-danger mt-3"
            v-if="_errorsExist && submitted"
        >Please make sure you've filled all the fields out correctly.</div>
        <div class="d-flex justify-content-begin">
            <button id="nextStep" class="mt-3 btn btn-primary" @click="nextStep">Next</button>
        </div>
    </div>
</template>

<script>
import TypeaheadInput from "@/components/inputs/TypeaheadInput.vue";
import CheckboxInput from "@/components/inputs/CheckboxInput.vue";
import TextInput from "@/components/inputs/TextInput.vue";
import SelectInput from "@/components/inputs/SelectInput.vue";
import RadioInput from '@/components/inputs/RadioInput.vue';
import NumberInput from '@/components/inputs/NumberInput.vue';
import { PROVINCES,ROLES } from "@/constants/constants.js";

export default {
    name: "StepOneForm",
    components: {
        TypeaheadInput,
        CheckboxInput,
        TextInput,
        SelectInput,
        RadioInput,
        NumberInput
    },
    data() {
        return {
            step: 1,
            submitted: false,
            provinces: PROVINCES,
            roles: ROLES,
            currencySelect: [
                { value: 'CAD', text: 'CAD' },
                { value: 'USD', text: 'USD' },
            ],
        };
    },
    computed: {
        formType() {
            return this.$store.getters.formType;
        },
        productionCompanies() {
            return this.$store.getters.getProductionCompanies;
        },
        companyListLoading() {
            return this.$store.getters.getProdCompanyLoadStatus;
        },
        manager() {
            const {
                FirstName,
                LastName,
                Phone,
                Email
            } = this.$store.getters.getUser;
            return {
                name: FirstName + " " + LastName,
                phone: Phone,
                email: Email
            };
        },
        manager2: {
            get() {
                return this.$store.state.newManager;
            },
            set(value) {
                //this.$store.dispatch("TOGGLE_NEW_MANAGER", value);
                this.$store.dispatch('SETSTATE_VALUE',{name:'newManager',value:value,type:'Boolean'});
                if(!value)
                {
                    //clear values
                    this.Manager2Role='';
                    this.Manager2FirstName='';
                    this.Manager2LastName='';
                    this.Manager2Email='';
                    this.Manager2Phone='';
                    this.submitted = false;
                }  
            }
        },
        isUserLocManager: {
            get() {
                //return this.$store.state.isUserLocManager;
                var locManager = this.$store.state.isUserLocManager
                
                if(locManager)
                {
                    //initialize values
                    //this.UserRole='';
                    /*this.LocManagerFirstName='';
                    this.LocManagerLastName='';
                    this.LocManagerEmail='';
                    this.LocManagerPhone='';
                    this.submitted = false;*/
                }  
                
                return locManager;
                
            },
            set(value) {
                //this.$store.dispatch("TOGGLE_NEW_MANAGER", value);
                this.$store.dispatch('SETSTATE_VALUE',{name:'isUserLocManager',value:value,type:'Boolean'});
                if(!value)
                {
                    //clear values
                    this.UserRole='';
                    this.LocManagerFirstName='';
                    this.LocManagerLastName='';
                    this.LocManagerEmail='';
                    this.LocManagerPhone='';
                    this.submitted = false;
                }  
            }
        },
        CompanyName: {
            get() {
                return this.$store.state.formData.CompanyName;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "CompanyName",
                    data: value
                });
            }
        },
        CompanyEmail: {
            get() {
                return this.$store.state.formData.CompanyEmail;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "CompanyEmail",
                    data: value
                });
            }
        },
        CompanyPhone: {
            get() {
                return this.$store.state.formData.CompanyPhone;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "CompanyPhone",
                    data: value
                });
            }
        },
        CompanyAddressLine1: {
            get() {
                return this.$store.state.formData.CompanyAddressLine1;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "CompanyAddressLine1",
                    data: value
                });
            }
        },
        CompanyAddressLine2: {
            get() {
                return this.$store.state.formData.CompanyAddressLine2;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "CompanyAddressLine2",
                    data: value
                });
            }
        },
        CompanyCity: {
            get() {
                return this.$store.state.formData.CompanyCity;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "CompanyCity",
                    data: value
                });
            }
        },
        CompanyProvince: {
            get() {
                return this.$store.state.formData.CompanyProvince;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "CompanyProvince",
                    data: value
                });
            }
        },
        CompanyPostalCode: {
            get() {
                return this.$store.state.formData.CompanyPostalCode;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "CompanyPostalCode",
                    data: value
                });
            }
        },
        newCompany: {
            get() {
                return this.$store.getters.newProductionCompany;
            },
            set(event) {
                this.$store.dispatch("TOGGLE_NEW_PROD_COMPANY", event);
            }
        },
        Manager2Role: {
            get() {
                return this.$store.state.formData.Manager2Role;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "Manager2Role",
                    data: value
                });
            }
        },
        Manager2FirstName: {
            get() {
                return this.$store.state.formData.Manager2FirstName;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "Manager2FirstName",
                    data: value
                });
            }
        },
        Manager2LastName: {
            get() {
                return this.$store.state.formData.Manager2LastName;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "Manager2LastName",
                    data: value
                });
            }
        },
        Manager2Email: {
            get() {
                return this.$store.state.formData.Manager2Email;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "Manager2Email",
                    data: value
                });
            }
        },
        Manager2Phone: {
            get() {
                return this.$store.state.formData.Manager2Phone;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "Manager2Phone",
                    data: value
                });
            }
        },
        UserRole: {
            get() {
                return this.$store.state.formData.UserRole;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "UserRole",
                    data: value
                });
            }
        },
        LocManagerFirstName: {
            get() {
                return this.$store.state.formData.LocManagerFirstName;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "LocManagerFirstName",
                    data: value
                });
            }
        },
        LocManagerLastName: {
            get() {
                return this.$store.state.formData.LocManagerLastName;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "LocManagerLastName",
                    data: value
                });
            }
        },
        LocManagerEmail: {
            get() {
                return this.$store.state.formData.LocManagerEmail;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "LocManagerEmail",
                    data: value
                });
            }
        },
        LocManagerPhone: {
            get() {
                return this.$store.state.formData.LocManagerPhone;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "LocManagerPhone",
                    data: value
                });
            }
        },
        StudioLocation: {
            get() {
                return this.$store.state.formData.StudioLocation;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "StudioLocation",
                    data: value
                });
            }
        },
        NumOfStudioDays: {
            get() {
                return this.$store.state.formData.NumOfStudioDays;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "NumOfStudioDays",
                    data: value
                });
            }
        },
        ProductionManager: {
            get() {
                return this.$store.state.formData.ProductionManager;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "ProductionManager",
                    data: value
                });
            }
        },
        ProducerName: {
            get() {
                return this.$store.state.formData.ProducerName;
            },
            set(value) {
                this.$store.dispatch("UPDATE_FORM_FIELD", {
                    field: "ProducerName",
                    data: value
                });
            }
        },
        TOTALPRODBUDGET: {
            get() {
                return this.$store.state.formData.TOTALPRODBUDGET;
            },
            set(value) {
                this.$store.dispatch('UPDATE_FORM_FIELD', {
                    field: 'TOTALPRODBUDGET',
                    data: Number(value),
                });
            },
        },
        TOTCADCB: {
            get() {
                if (this.$store.state.formData.TOTCADCB == 'Y') {
                    return 'CAD';
                } else {
                    return 'USD';
                }
            },
            set(value) {
                if (value == 'CAD') {
                    this.$store.dispatch('UPDATE_FORM_FIELD', {
                        field: 'TOTCADCB',
                        data: 'Y',
                    });
                    this.$store.dispatch('UPDATE_FORM_FIELD', {
                        field: 'TOTALUSDCB',
                        data: 'N',
                    });
                } else {
                    this.$store.dispatch('UPDATE_FORM_FIELD', {
                        field: 'TOTCADCB',
                        data: 'N',
                    });
                    this.$store.dispatch('UPDATE_FORM_FIELD', {
                        field: 'TOTALUSDCB',
                        data: 'Y',
                    });
                }
            },
        },
        ESTSPEND: {
            get() {
                return this.$store.state.formData.ESTSPEND;
            },
            set(value) {
                this.$store.dispatch('UPDATE_FORM_FIELD', {
                    field: 'ESTSPEND',
                    data: Number(value),
                });
            },
        },
        ESTCADCB: {
            get() {
                if (this.$store.state.formData.ESTCADCB == 'Y') {
                    return 'CAD';
                } else {
                    return 'USD';
                }
            },
            set(value) {
                if (value == 'CAD') {
                    this.$store.dispatch('UPDATE_FORM_FIELD', {
                        field: 'ESTCADCB',
                        data: 'Y',
                    });
                    this.$store.dispatch('UPDATE_FORM_FIELD', {
                        field: 'ESTUSDCB',
                        data: 'N',
                    });
                } else {
                    this.$store.dispatch('UPDATE_FORM_FIELD', {
                        field: 'ESTCADCB',
                        data: 'N',
                    });
                    this.$store.dispatch('UPDATE_FORM_FIELD', {
                        field: 'ESTUSDCB',
                        data: 'Y',
                    });
                }
            },
        },
        typeaheadList() {
            return this.productionCompanies.map(company => company.CompanyName);
        },
        selectedCompany() {
            if (this.CompanyName) {
                return this.productionCompanies.filter(
                    company => company.CompanyName == this.CompanyName
                )[0];
            } else {
                return {
                    CompanyName: "",
                    CompanyEmail: "",
                    CompanyPhone: "",
                    CompanyAddressLine1: "",
                    CompanyAddressLine2: "",
                    CompanyCity: "",
                    CompanyProvince: "",
                    CompanyPostalCode: ""
                };
            }
        },
        loading() {
            return this.$store.getters.isLoading;
        }
    },
    methods: {
        nextStep() {
            this.submitted = true;
            if (!this._errorsExist()) {
                this.$store.dispatch("COMPLETE_STEP", {
                    step: this.step,
                    complete: true
                });
                this.$emit('nextStep');
            }
        },
        handleTypeaheadInput(e) {
            var selectedCompany = this.productionCompanies.filter(
                company => company.CompanyName == e
            )[0];

            if (typeof selectedCompany == "object") {
                Object.keys(selectedCompany).map(field => {
                    this.$store.dispatch("UPDATE_FORM_FIELD", {
                        field: field,
                        data: selectedCompany[field]
                    });
                });
            }
        }
    },
    mounted() {
        document.getElementById("stepOneForm").focus();
        this.newCompany = this.$store.getters.newProductionCompany;
    }
};
</script>
